export const isNew = (id?: string) => id === undefined || id.toLowerCase() === "new";
